import script from "./addModal.vue?vue&type=script&setup=true&lang=js"
export * from "./addModal.vue?vue&type=script&setup=true&lang=js"

import "./addModal.vue?vue&type=style&index=0&id=4d82fd7e&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d82fd7e"]])

export default __exports__